<template>
  <div class="bread-crumb">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="(item, index) in breadList"
        :key="index"
        @click.native="breadPath(item, index)"
        :class="{ 'click-bread': index < len }"
        >{{ item.meta.titleShow }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      this.getBreadCrumb()
    }
  },
  data() {
    return {
      breadList: [],
      len: 0
    }
  },
  mounted() {
    this.getBreadCrumb()
  },
  methods: {
    getBreadCrumb() {
      const matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      )
      this.breadList = matched
      if (
        location.href.indexOf('/version') !== -1 ||
        location.href.indexOf('/equipment') !== -1
      ) {
        const obj = {
          meta: {
            title: '产品信息'
          },
          path: '/production',
          parent: {
            path: ''
          }
        }
        this.breadList.unshift(obj)
      }
      const proName = decodeURI(location.href.split('&proName=')[1])
      this.breadList.forEach((item) => {
        if (item.path === '/equipment' || item.path === '/version') {
          item.meta.titleShow = proName + ' ' + item.meta.title
        } else {
          item.meta.titleShow = item.meta.title
        }
      })
      this.len = this.breadList.length - 1
    },
    breadPath(e, index) {
      if (index === this.breadList.length - 1 || e.path === '/manage') return
      this.$router.push(e.path)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .click-bread .el-breadcrumb__inner {
    color: #66b1ff;
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
  }
}
</style>
